// src/components/atoms/landing/testimonial-avatar.tsx
import Image from "next/image";
import { cn } from "@/lib/utils";

export type TestimonialAvatarItem = {
  src: string;
  alt: string;
};

type TestimonialAvatarProps = TestimonialAvatarItem & {
  size?: number;
  ringClassName?: string;
  className?: string;
};

export function TestimonialAvatar({
  src,
  alt,
  size = 48,
  ringClassName = "ring-white",
  className,
}: TestimonialAvatarProps) {
  return (
    <span
      className={cn(
        "relative inline-block overflow-hidden rounded-full bg-gradient-to-br from-brand via-brand-mint to-brand-ink ring-4",
        ringClassName,
        className,
      )}
      style={{ width: size, height: size }}
    >
      <Image
        src={src}
        alt={alt}
        width={size}
        height={size}
        className="size-full object-cover"
      />
    </span>
  );
}

type TestimonialAvatarStackProps = {
  avatars: TestimonialAvatarItem[];
  max?: number;
  size?: number;
  ringClassName?: string;
  className?: string;
};

export function TestimonialAvatarStack({
  avatars,
  max = 5,
  size = 48,
  ringClassName,
  className,
}: TestimonialAvatarStackProps) {
  const visible = avatars.slice(0, max);
  return (
    <div className={cn("flex -space-x-3", className)}>
      {visible.map((a, i) => (
        <TestimonialAvatar
          key={`${a.src}-${i}`}
          src={a.src}
          alt={a.alt}
          size={size}
          ringClassName={ringClassName}
        />
      ))}
    </div>
  );
}
